import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import React, { useState } from 'react';
import { weakKey } from '../../../../utilities/weakKey';
import { ConfirmationTypes } from './ConfirmationTypes';
import { Column, Columns } from '@codeparva/ui-components-library';

export const Accordion = ({
  contentArr,
  theme = 'light',
}: ConfirmationTypes.TConfirmationAccordian) => {
  const themeConfig = {
    textColor: 'primary',
    sectionBackgroundColor: 'secondary',
  };

  if (theme === 'dark') {
    themeConfig.textColor = 'secondary';
    themeConfig.sectionBackgroundColor = 'primary';
  }

  const [active, setActive] = useState<number | undefined>(undefined);
  const openingIcon = 'FaMinus';
  const closingIcon = 'FaPlus';

  const toggleAccordion = (index: number) => {
    return active === index ? setActive(undefined) : setActive(index);
  };

  const getIcon = (clickedAccIndex: number) => {
    return active === clickedAccIndex ? closingIcon : openingIcon;
  };
  const getColumnSize = (key: string) => {
    switch (key) {
      case 'tenantInfo':
      case 'alternateInfo':
      case 'moveInDetails':
        return 'is-3';
      case 'dlInfo':
        return 'is-5';
      case 'militaryInfo':
        return 'is-6';
    }
  };
  const AccordianListContainer = ({
    individualItem,
  }: ConfirmationTypes.TIndividalFields) => {
    return (
      <>
        {individualItem.label !== '' && individualItem.value !== '' ? (
          <Columns
            multiline={false}
            marginless
            className="accordionListContainer p-1"
            key={weakKey({ individualItem })}
          >
            <Column
              paddingless
              className={`${getColumnSize(
                individualItem.key
              )} accordianListColumnLabel`}
            >
              <label className={`accordionList has-text-text content1`}>
                {individualItem.label}:{' '}
              </label>
            </Column>
            <Column paddingless className="accordianListColumnValue">
              <span className={`accordionList has-text-text content1`}>
                {individualItem.value}{' '}
              </span>
            </Column>
          </Columns>
        ) : (
          <></>
        )}
        <br />
      </>
    );
  };

  const AccordionItemList = ({ individualFields }: any) => {
    return (
      <div className="accordionContainer">
        {individualFields.map((individualItem: ConfirmationTypes.TFields) => (
          <AccordianListContainer
            individualItem={individualItem}
            key={weakKey(individualItem)}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="accordionSection">
      {contentArr.map((content: ConfirmationTypes.TConfirmationSection, i) => {
        return (
          <div className="accordionSubSection" key={weakKey(content)}>
            <button
              type="button"
              className={`accordionHeadingSection is-align-items-center  is-flex flex-direction-row is-justify-content-space-between has-background-${themeConfig.sectionBackgroundColor} ${theme}Br`}
              onClick={() => toggleAccordion(i)}
            >
              <h5
                className={`has-text-weight-bold has-text-${themeConfig.textColor}`}
              >
                {content.title}
              </h5>

              <FontAwesomeIcon
                iconClassName={getIcon(i)}
                iconContextProps={{
                  className: `has-text-${themeConfig.textColor}`,
                }}
              />
            </button>
            <div>
              {active === i ? (
                <></>
              ) : (
                <AccordionItemList individualFields={content.fields} />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
